// 导出通用 二次确认弹出框封装
function downloadTips(prompt, callback, callback1){
    var _this = window.Vue;
    _this.$confirm('<p>文件下载成功！请到文件“下载中心”下载。</p>'+prompt, "操作提示", {
        confirmButtonText: '知道了',
        dangerouslyUseHTMLString: true,
        cancelButtonText: '去往下载中心',
        closeOnClickModal:false,
        closeOnPressEscape:false,
        showClose:false,
        roundButton:true,
        distinguishCancelAndClose: true,
        type: 'success'
      }).then(() => {
        callback()
      }).catch(()=>{
        callback1()
      });
}
export default {
    MsgBox:function(prompt, callback, callback1){
      return downloadTips(prompt, callback, callback1)
    }
}


// WEBPACK FOOTER //
// ./src/assets/script/downloadTips.js